import { cwslapi } from "../index";


// 获取下载页信息
export const getdownLoadApi = () => {
  return cwslapi({
    url: "/public/getdownLoad",
    method: "get"
  });
};